/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SortBy {
  ALL_PLANS = 'ALL_PLANS',
  BEST_MATCH = 'BEST_MATCH',
  ALL_IN_COST = 'ALL_IN_COST',
  PREMIUM = 'PREMIUM',
  DEDUCTIBLE = 'DEDUCTIBLE',
  MAX_OUT_OF_POCKET = 'MAX_OUT_OF_POCKET',
}
